export default __webpack_public_path__ + "static/media/file-upload.a68d497b.svg";